<template>
  <!--<el-dropdown trigger="click" class="region-switcher mb-5" v-if="region">-->
    <span class="left-border" :class="isMobile ? 'clear-dropdown' : ''">
      <template v-if="currency">({{ $t('app.currency') }}: {{ currency }})</template>
      <!--<img :src="`/static/flags/${region}.png`" :class="['flag', region]" class="ml-5"/>-->
    </span>
    <!--<el-dropdown-menu class="switcher-dropdown-menu region" slot="dropdown">-->
      <!--<el-dropdown-item>-->
        <!--<a href="javascript:void(0);"-->
           <!--:class="{ active: region === ipRegion}"-->
           <!--@click="switchRegion(ipRegion)" v-if="ipRegion"-->
        <!--&gt;-->
          <!--{{ regionsNames[ipRegion][0] }}-->
          <!--<img :src="`/static/flags/${ipRegion}.png`" :class="['flag', ipRegion]" />-->
        <!--</a>-->
      <!--</el-dropdown-item>-->
      <!--<el-dropdown-item>-->
        <!--<router-link :to="{ name: 'choose-country-region' }">{{ $t('state.choose_your_country_or_region') }}</router-link>-->
      <!--</el-dropdown-item>-->
    <!--</el-dropdown-menu>-->
  <!--</el-dropdown>-->
</template>

<script>
  import { mapState, mapGetters } from 'vuex';

  export default {
    name: 'RegionSwitcher',
    data() {
      return {
        ipRegion: '',
      };
    },
    mounted() {
      this.$api.app.ipInfo().then((ipInfo) => {
        // eslint-disable-next-line
        this.ipRegion = ipInfo.country_id === 'xx' ? 'HK' : ipInfo.country_id;
      }).catch(() => {
        this.ipRegion = 'HK';
      });
    },
    computed: {
      ...mapState({
        region: state => state.app.region,
        currency: state => state.app.currency,
      }),
      ...mapGetters([
        'isMobile',
        'regionsNames',
      ]),
    },
    methods: {
      switchRegion(region) {
        this.$store.dispatch('setRegion', { region }).then(() => {
          window.location.href = window.location.origin;
        }).catch(() => {});
      },
    },
  };
</script>

<style lang="scss" scoped>
  .el-dropdown{
    span {
      padding: 4px 5px !important;
    }
  }
  .region {
    li {
      a {
        text-align: right;
      }
    }
  }
  .el-dropdown + .el-dropdown {
    margin-left: 5px;
  }
  .region-switcher {
    margin-top: 4px;
    .flag {
      &.TW {
        display: none;
      }
    }
  }
</style>
